export interface RemoteGateway {
    id: ID;
    object?: RemoteGatewayObject;
    publicKey?: string;
    type: RemoteGatewayType;
    credentials?: { apiLoginId: string; transactionKey: string };
}

export enum RemoteGatewayType {
    STRIPE_XOLA = "stripe_xola",
    STRIPE_XOLA_CANADA = "stripe_xola_canada",
    STRIPE_OAUTH = "stripe_oauth",
    STRIPE_API_KEY = "stripe_api_key",
    AUTHORIZE_NET_AIM = "authorize_net_aim",
    AUTHORIZE_NET_CIM = "authorize_net_cim",
    CYBERSOURCE = "cybersource",
}

export enum RemoteGatewayObject {
    STRIPE = "stripe_remote_gateway",
    CUSTOM = "remote_gateway",
}

export enum RemoteGatewayName {
    AUTHORIZE_NET_CIM = "AuthorizeNet_CIM",
}

export enum RemoteGatewayAuthenticationType {
    API_KEY = "apiKey",
    OAUTH = "oauth",
}
